import { InformationItemContainer, SearchContainer } from "../../components"

const AllInformationItems = () => {
    return (
        <>
            <SearchContainer />
            <InformationItemContainer />
        </>
    )
}

export default AllInformationItems